.gallery {
    border-radius: 0;
    overflow: hidden;
    background-color: transparent;
    max-width: 400px;
    width: 100%;
}

.gallery--outbound {
    composes: gallery;
    background-color: transparent;
}

.gallery-grid {
    display: grid;
    gap: 8px;
}

.gallery-grid--single {
    composes: gallery-grid;
    grid-template-columns: 1fr;
    max-height: 300px;
}

.gallery-grid--double {
    composes: gallery-grid;
    grid-template-columns: 1fr 1fr;
    max-height: 200px;
}

.gallery-grid--triple {
    composes: gallery-grid;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 1fr 1fr;
    max-height: 200px;
}

.gallery-grid--triple .image-container:first-child {
    grid-row: 1 / 3;
}

.gallery-grid--multiple {
    composes: gallery-grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    max-height: 250px;
}

.image-container {
    position: relative;
    min-height: 100px;
    background-color: var(--grey-xlt);
    overflow: hidden;
    border-radius: 8px;
}

.gallery-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
    transition:
        transform 0.2s ease,
        opacity 0.2s ease;
}

.gallery-image--clickable:hover {
    transform: scale(1.02);
}

.gallery-image--loading {
    opacity: 0;
}

.gallery-image--error {
    display: none;
}

.image-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--grey-xlt);
}

.loading-spinner {
    width: 24px;
    height: 24px;
    border: 2px solid var(--grey-lt);
    border-top: 2px solid var(--blue);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.image-error {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--grey-xlt);
    color: var(--grey);
}

.error-icon {
    font-size: 24px;
    margin-bottom: 4px;
}

.error-text {
    font-size: var(--font-size-mini);
    text-align: center;
}

.image-count {
    display: none;
}

.more-images-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    color: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    border-radius: 8px;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    cursor: pointer;
}

.modal-content {
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    cursor: default;
}

.modal-close {
    position: absolute;
    top: -40px;
    right: 0;
    background: none;
    border: none;
    color: var(--white);
    font-size: 32px;
    cursor: pointer;
    padding: 8px;
    z-index: 1001;
    transition: opacity 0.2s ease;
}

.modal-close:hover {
    opacity: 0.7;
}

.modal-image-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-image {
    max-width: 100%;
    max-height: 90vh;
    object-fit: contain;
    border-radius: 8px;
}

.modal-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    border: none;
    color: var(--white);
    font-size: 32px;
    padding: 16px 20px;
    cursor: pointer;
    border-radius: 50%;
    transition: background-color 0.2s ease;
    z-index: 1001;
}

.modal-nav:hover {
    background-color: rgba(0, 0, 0, 0.8);
}

.modal-nav--prev {
    left: -60px;
}

.modal-nav--next {
    right: -60px;
}

.modal-counter {
    position: absolute;
    bottom: -40px;
    left: 50%;
    transform: translateX(-50%);
    color: var(--white);
    font-size: 14px;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 8px 16px;
    border-radius: 16px;
}

/* Responsive adjustments */
@media (max-width: 600px) {
    .gallery {
        max-width: 280px;
    }

    .gallery-grid--single {
        max-height: 220px;
    }

    .gallery-grid--double,
    .gallery-grid--triple,
    .gallery-grid--multiple {
        max-height: 160px;
    }

    .modal-nav--prev {
        left: 10px;
    }

    .modal-nav--next {
        right: 10px;
    }

    .modal-nav {
        font-size: 24px;
        padding: 12px 16px;
    }

    .modal-close {
        top: 10px;
        right: 10px;
        font-size: 24px;
    }

    .modal-counter {
        bottom: 10px;
    }
}
